import { FC } from 'react';
import { fileBadgeFormat } from 'utils/FileUtils';

interface Props {
  fileName?: string | null;
  // Height in pixels. The page is a little narrower than it is tall.
  size?: number;
  className?: string;
}

// A page with a folded corner in the file type's colour, labelled with the
// format, like "PDF" on red. Ported from the Mac app's MacFileTypeBadge.
export const FileTypeBadge: FC<Props> = ({
  fileName,
  size = 38,
  className,
}) => {
  const { label, color } = fileBadgeFormat(fileName);
  const width = size * 0.84;
  const fold = size * 0.3;
  const radius = size * 0.18;

  // Page outline: rounded corners except the top right, which is cut off by
  // the fold.
  const page = [
    `M ${radius} 0`,
    `H ${width - fold}`,
    `L ${width} ${fold}`,
    `V ${size - radius}`,
    `A ${radius} ${radius} 0 0 1 ${width - radius} ${size}`,
    `H ${radius}`,
    `A ${radius} ${radius} 0 0 1 0 ${size - radius}`,
    `V ${radius}`,
    `A ${radius} ${radius} 0 0 1 ${radius} 0`,
    'Z',
  ].join(' ');
  const foldShape = `M ${width - fold} 0 V ${fold} H ${width} Z`;

  return (
    <svg
      width={width}
      height={size}
      viewBox={`0 0 ${width} ${size}`}
      className={className}
      aria-hidden="true"
    >
      <path d={page} fill={color} />
      <path d={foldShape} fill="rgba(0,0,0,0.22)" />
      <text
        x={width / 2}
        y={size * 0.6}
        textAnchor="middle"
        dominantBaseline="middle"
        fill="white"
        fontSize={size * 0.26}
        fontWeight={700}
        fontFamily="inherit"
      >
        {label}
      </text>
    </svg>
  );
};
